export enum ButtonTypes {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	TERTIARY = 'tertiary',
	LOADING = 'loading',
}
